import Vue from 'vue';
import store from '@/store';
import { loaderLessAPIs } from '@/utils/endpoint';

export default class ApiService {
  static setLoader() {
    store.dispatch('master/setLoaderState', true);
  }
  static removeLoader() {
    store.dispatch('master/setLoaderState', false);
  }
  static post(url, requestData) {
    const p = new Promise((resolve, reject) => {
      const noLoader = loaderLessAPIs.filter(m => m.includes(url));
      if (!(noLoader && noLoader.length))
        this.setLoader();
      Vue.$http.post(url, requestData)
        .then((data) => {
          this.removeLoader();
          setTimeout(() => { resolve(data.data); }, 300);
        })
        .catch((error) => {
          this.removeLoader();
          setTimeout(() => { reject(error.response.data); }, 300);
        });
    });
    return p;
  }
  // TODO::Remove removeHeader variable
  static get(url, requestparams, _removeHeader) {
    const p = new Promise((resolve, reject) => {
      const noLoader = loaderLessAPIs.filter(m => m.includes(url));
      if (!(noLoader && noLoader.length))
        this.setLoader();
      Vue.$http.get(url, {
        params: requestparams,
      })
        .then((data) => {
          this.removeLoader();
          setTimeout(() => { resolve(data.data); }, 300);
        })
        .catch((error) => {
          this.removeLoader();
          setTimeout(() => { reject(error.response.data); }, 300);
        });
    });
    return p;
  }
  static put(url, requestData) {
    const p = new Promise((resolve, reject) => {
      this.setLoader();
      Vue.$http.put(url, requestData)
        .then((data) => {
          this.removeLoader();
          setTimeout(() => { resolve(data.data); }, 300);
        })
        .catch((error) => {
          this.removeLoader();
          setTimeout(() => { reject(error.response.data); }, 300);
        });
    });
    return p;
  }
  static delete(url, requestparams) {
    const p = new Promise((resolve, reject) => {
      const noLoader = loaderLessAPIs.filter(m => m.includes(url));
      if (!(noLoader && noLoader.length))
        this.setLoader();
      Vue.$http.delete(`${url}${requestparams}/`)
        .then((data) => {
          this.removeLoader();
          setTimeout(() => { resolve(data.data); }, 300);
        })
        .catch((error) => {
          this.removeLoader();
          setTimeout(() => { reject(error.response.data); }, 300);
        });
    });
    return p;
  }
  static deleteWithParams(url, requestparams) {
    const p = new Promise((resolve, reject) => {
      const noLoader = loaderLessAPIs.filter(m => m.includes(url));
      if (!(noLoader && noLoader.length))
        this.setLoader();
      Vue.$http.delete(url, { params: requestparams })
        .then((data) => {
          this.removeLoader();
          setTimeout(() => { resolve(data.data); }, 300);
        })
        .catch((error) => {
          this.removeLoader();
          setTimeout(() => { reject(error.response.data); }, 300);
        });
    });
    return p;
  }
}

// loader function goes here.



// WEBPACK FOOTER //
// ./src/services/commonApi.js